module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title1"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" I: H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELLTOWN")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-1"
    }
  }, [_vm._v("A Legend Retold")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-2"
    }
  }, [_vm._v("Origin of the Story and Name")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-3"
    }
  }, [_vm._v("Crybaby Bridge")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-4"
    }
  }, [_vm._v("The Road to Hell")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-5"
    }
  }, [_vm._v("The House in the Woods")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-6"
    }
  }, [_vm._v("The Murder Bus")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-7"
    }
  }, [_vm._v("Cultists’ Church")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-8"
    }
  }, [_vm._v("Haunted Cemeteries")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-9"
    }
  }, [_vm._v("The Slaughterhouse")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-10"
    }
  }, [_vm._v("The Toxic Waste Dump")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-11"
    }
  }, [_vm._v("A Legend Concluded")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" II: W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITCHES")]), _vm._v("’ G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAVES")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The West Branch Witch")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Cedar Grove Witch of Peninsula")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Witch’s Ball of Valley City")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Witch’s Grave of Olmsted Falls")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mary Jane’s Grave")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The German Witches’ Graves")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bowman Cemetery Witch")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Real Witches’ Graves")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" III: R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AILROAD")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOSTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ashtabula Bridge Disaster")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Republic Horror")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ghostly Wails at the Front Avenue Crossing")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Arcadia’s Headless Ghost")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sprightly Specter of Conneaut")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Kipton Collision")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Death on the Doodlebug")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Alphabet Railroad Powerhouse")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" IV: C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RYBABY")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIDGES")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Storied Bridges")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Haunted Crossings")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Actual Incidents")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("True Cases")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" V: H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUNTED")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVERNS AND")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ODGINGS")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wolf Creek Tavern")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("West Richfield Hotel")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Punderson Manor")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Old Stone House Bed and Breakfast")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rider’s Inn")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unionville Tavern")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#C6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" VI: H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUNTED")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EMETERIES")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#C6-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#C6-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wolfinger Cemetery")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#C6-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("River Styx Cemetery")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#C6-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cholera Cemetery")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#C6-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Showman-Edwards Cemetery")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#C6-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Angel at Maple Grove Cemetery")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#C6-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Abbotts’ Tomb")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" VII: C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANAL")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOSTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wilson Feed Mill")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ghosts of the Lonesome Lock")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deep Lock and Quarry")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Johnnycake Lock")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Akron Civic Theatre")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Clinton Guard Lock Mill")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Warehouse on the Canal")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lock 4 Park")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bucklin’s Lock")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gretchen’s Lock")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Tragedy of Jake’s Lock")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter8#C8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" VIII: G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORE")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RPHANAGE")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter8#C8-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Legend of Gore Orphanage")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter8#C8-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sprungers")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter8#C8-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The First Orphanage")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter8#C8-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lorain County")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter8#C8-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rosedale")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter8#C8-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Deaconess Hospital")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter8#C8-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Investigation and Other Troubles")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter8#C8-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Orphanage Meets Its End")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter8#C8-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Final Disposition")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 63
// module chunks = 0